import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "@translations/en.json";
import de from "@translations/de.json";
import fr from "@translations/fr.json";
import it from "@translations/it.json";
import pl from "@translations/pl.json";
import esLatam from "@translations/es-419.json";
import esSpain from "@translations/es-ES.json";
import ptBr from "@translations/pt-BR.json";
import ptPt from "@translations/pt-PT.json";

const resources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
  fr: {
    translation: fr,
  },
  it: {
    translation: it,
  },
  pl: {
    translation: pl,
  },
  "es-419": {
    translation: esLatam,
  },
  "es-ES": {
    translation: esSpain,
  },
  "pt-BR": {
    translation: ptBr,
  },
  "pt-PT": {
    translation: ptPt,
  },
};

export const options = {
  fallbackLng: {
    "es-ES": ["es-ES", "es-419", "en"],
    es: ["es-419", "en"],
    "pt-PT": ["pt-PT", "pt-BR", "en"],
    pt: ["pt-BR", "en"],
    default: ["en"],
  },
  resources,
  detection: {
    order: ["navigator"],
  },
};

export const initI18n = async () => {
  if (!i18n.isInitialized) {
    await i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init(options);
  }
  window.i18n = i18n;
  return i18n;
};

export default i18n;
